var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1613 4.25183C29.9896 -1.41728 38.0104 -1.41728 39.8387 4.25184L43.4736 15.5226C44.2924 18.0615 46.658 19.7802 49.3257 19.7744L61.168 19.7485C67.1247 19.7355 69.6032 27.3637 64.7766 30.8544L55.1807 37.7942C53.0191 39.3575 52.1155 42.1385 52.9454 44.6738L56.6295 55.9285C58.4826 61.5896 51.9936 66.3041 47.1822 62.7924L37.6168 55.8107C35.462 54.2379 32.5379 54.2379 30.3832 55.8107L20.8177 62.7924C16.0064 66.3041 9.5174 61.5896 11.3705 55.9285L15.0546 44.6738C15.8845 42.1385 14.9809 39.3575 12.8193 37.7942L3.2234 30.8544C-1.60327 27.3637 0.875301 19.7355 6.83193 19.7485L18.6743 19.7744C21.3419 19.7802 23.7076 18.0615 24.5264 15.5226L28.1613 4.25183Z",
    fill: "#FF5C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8936 47.8733C32.1717 49.2224 34.9785 49.2224 37.2566 47.8733L44.7359 43.4441C42.5078 39.4943 38.344 36.8369 33.5751 36.8369C28.8062 36.8369 24.6424 39.4943 22.4143 43.4441L29.8936 47.8733Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5.31378,
    transform: "matrix(1 0 0 -1 33.5749 25.8588)",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a5c3ce211e73941923e1f6106c02d958.svg";
export { ForwardRef as ReactComponent };